var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getSonarObjectTypeLabelPlural } from '@sonar-software/sonar-ts-lib';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { SelectionTable } from '@ui/tables';
import { AutomationSearch, PeriscopeAutomation } from '.';
import { getRowKey, paginationDefaultQueryParams } from '..';
import { SfEntityAutomationType, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useRef } from 'react';
import { useBulkSelectWorkflow, useQueryResource, useSelectionTable } from '@hooks';
export const automationToSonarObjectTypeMap = {
    [SfEntityAutomationType.EmailAlerts]: SonarObjectType.SalesforceWorkflowAlert,
    [SfEntityAutomationType.ApexClasses]: SonarObjectType.SalesforceApexClass,
    [SfEntityAutomationType.ApexTriggers]: SonarObjectType.SalesforceApexTrigger,
    [SfEntityAutomationType.EmailTemplate]: SonarObjectType.SalesforceEmailTemplate,
    [SfEntityAutomationType.FieldUpdates]: SonarObjectType.SalesforceFieldUpdate,
    [SfEntityAutomationType.Flows]: SonarObjectType.SalesforceFlow,
    [SfEntityAutomationType.FormulaFields]: SonarObjectType.SalesforceField,
    [SfEntityAutomationType.PageLayouts]: SonarObjectType.SalesforcePageLayout,
    [SfEntityAutomationType.ProcessBuilders]: SonarObjectType.SalesforceProcessBuilder,
    [SfEntityAutomationType.ValidationRules]: SonarObjectType.SalesforceValidationRule,
    [SfEntityAutomationType.Workflows]: SonarObjectType.SalesforceWorkflowRule,
    [SfEntityAutomationType.AllProcessAutomations]: null
};
export const SalesforceAutomationSearchableSelectionTable = ({ childSonarObjectType, parentIndex, parentSonarObjectType, sonarObjectId, type, uri }) => {
    const scrollableListRef = useRef(null);
    const sonarObjectType = automationToSonarObjectTypeMap[type || SfEntityAutomationType.AllProcessAutomations];
    const selectionTypeLabel = type === SfEntityAutomationType.AllProcessAutomations ?
        `${PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION}s` :
        getSonarObjectTypeLabelPlural(sonarObjectType);
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: Object.assign(Object.assign({}, paginationDefaultQueryParams), { hideInactive: true, type }),
        uri
    });
    const { resourceIdsUri } = useBulkSelectWorkflow({
        childType: childSonarObjectType,
        parentType: parentSonarObjectType,
        sonarObjectId: sonarObjectId
    });
    const { type: automationType } = queryParams, queryParamsTypeRemoved = __rest(queryParams, ["type"]);
    const selectionData = useSelectionTable({
        getRowKey,
        queryParams: queryParamsTypeRemoved,
        resourceIdsUri: resourceIdsUri,
        results: resource,
        selectionType: sonarObjectType
    });
    const renderAutomations = useCallback((automation) => React.createElement(PeriscopeAutomation, { automation: automation, parentIndex: parentIndex, showType: type === SfEntityAutomationType.AllProcessAutomations }), [parentIndex, type]);
    return (React.createElement(React.Fragment, null,
        React.createElement(AutomationSearch, { onChange: updateParams, queryParams: queryParams }),
        React.createElement(SelectionTable, { dataSource: resource, loading: loading, ref: scrollableListRef, renderRow: renderAutomations, rowKey: getRowKey, selectionData: selectionData, selectionType: selectionTypeLabel })));
};
